(function () {
    function initLazyImages() {
        const lazyImages = [].slice.call(document.querySelectorAll("img.lazyload"));

        if ("IntersectionObserver" in window) {
            const lazyObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        img.src = img.dataset.src;
                        img.classList.add("loaded"); // Optional: Add fade-in effect
                        lazyObserver.unobserve(img);
                    }
                });
            }, { rootMargin: "500px 0px" }); // start loading well before the image scrolls into view
            lazyImages.forEach((img) => lazyObserver.observe(img));
        } else {
            // Fallback: Load all images immediately
            lazyImages.forEach((img) => img.src = img.dataset.src);
        }
    }

    // This script loads async: DOMContentLoaded may already have fired by the time we run.
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initLazyImages);
    } else {
        initLazyImages();
    }
})();
